import React, { useState } from 'react';
import { useLocalStorage } from '../hooks/useLocalStorage';
import useCookie from '../hooks/useCookie';

// TODO: Update types
export type AppContextType = {
  cart: any;
  setCart: any;
  andee: any;
  setAndee: any;
  db: any;
  sessionInfo: any;
  setSessionInfo: any;
  setDb: any;
  storage: any;
  setStorage: any;
  canCheckout: boolean;
  setCanCheckout: any;
};

const AppContext = React.createContext({} as AppContextType);

// @see - https://medium.com/analytics-vidhya/react-how-to-use-context-with-functional-components-240a8ec4126a
export const AppContextProvider = (props) => {
  const [cart, setCart] = useLocalStorage('cart', {
    tags: [],
  });
  const [db, setDb] = useState(null);
  const [storage, setStorage] = useState(null);
  const [andee, setAndee] = useCookie('andee');
  const [sessionInfo, setSessionInfo] = useCookie('andSessionInfo');
  const [canCheckout, setCanCheckout] = useState(true);
  const [popularTagIsPresent, setPopularTagIsPresent] = useState(false);

  const value = {
    cart,
    setCart,
    andee,
    setAndee,
    db,
    sessionInfo,
    setSessionInfo,
    setDb,
    storage,
    setStorage,
    canCheckout,
    setCanCheckout,
    popularTagIsPresent,
    setPopularTagIsPresent,
  };

  return (
    <AppContext.Provider value={value}>{props.children}</AppContext.Provider>
  );
};

export const useAppContext = () => React.useContext(AppContext);
